import React from "react";
import styled from "styled-components";
import DropdownHeading from "../shared/DropdownHeading";
import NavBlock from "../shared/NavBlock";
import SmallLink from "../shared/SmallLink";

import theme from "../../../styles/theme";

const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 0px;
  ${() => theme.media.tabletDown`
    > div {
      width: 100%;
    }
  `}
`;

const StyledSmallLink = styled(SmallLink)`
  ${() => theme.media.tabletDown`
    width: calc(100% / 2);
    margin: 0 0 30px;
  `}
  ${() => theme.media.tabletUp`
    width: calc(100% / 4);
    margin: 0 0 30px;
  `}
`;

const Container = ({ list }) => {
  return (
    <>
      {list.heading && <DropdownHeading>{list.heading}</DropdownHeading>}
      <StyledDiv>
        {list.links.map((link, i) => {
          if (link.type === "navBlock") {
            return <NavBlock key={`navblock_${i}`} navBlock={link} />;
          }
          return (
            <StyledSmallLink key={`small_link_${i}`} href={link.url} beta={link.beta}>
              {link.label}
            </StyledSmallLink>
          );
        })}
      </StyledDiv>
    </>
  );
};

export default Container;
